import { render, staticRenderFns } from "./ConceitosCadastro.vue?vue&type=template&id=d1e5d60c&"
import script from "./ConceitosCadastro.vue?vue&type=script&lang=js&"
export * from "./ConceitosCadastro.vue?vue&type=script&lang=js&"
import style0 from "./ConceitosCadastro.vue?vue&type=style&index=0&id=d1e5d60c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports